/**
 * Offline Sync Middleware
 * Automatically refreshes order lists when sync completes
 */

import syncEngine from '../offline/syncEngine';
import { listOrdersForBillingAPI, listHeldOrders } from '../component/Modules/Sales/Billing/API/viewOrderSection';

let hasSubscribed = false;

const offlineSyncMiddleware = store => {
  // Subscribe to sync engine events once
  if (!hasSubscribed) {
    syncEngine.subscribe(async (event) => {
      if (event.type === 'sync_completed') {
        console.log('🔄 Sync completed, refreshing order lists...');
        
        try {
          const state = store.getState();
          const branchId = state.loginResponseSlice?.value?.branchPk;
          const currentTab = state.topBarSliceBilling?.btnClicked;
          
          if (branchId) {
            // Refresh View Orders if on that tab
            if (currentTab === 'viewOrder') {
              console.log('📋 Refreshing View Orders...');
              await listOrdersForBillingAPI({ branchId, type: 2 });
            }
            
            // Refresh Held/Ongoing Orders if on that tab
            if (currentTab === 'heldOrder') {
              console.log('📋 Refreshing Ongoing Orders...');
              await listHeldOrders({ branchId, type: 1 });
            }
            
            // Always refresh ongoing count
            await listHeldOrders({ branchId, type: 1 });
            
            console.log('✅ Order lists refreshed successfully');
          }
        } catch (error) {
          console.error('❌ Error refreshing order lists:', error);
        }
      }
    });
    hasSubscribed = true;
  }

  return next => action => {
    return next(action);
  };
};

export default offlineSyncMiddleware;
